import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Profile from './Profile';
import UpdateProfile from './UpdateProfile';
import UpdatePwd from './UpdatePwd';

const ProfileRouter = () => {
  return (
    <Routes>
      <Route path="edit/:id" element={<UpdateProfile />} />
      <Route path="change-pwd" element={<UpdatePwd />} />
      <Route index element={<Profile />} />
    </Routes>
  );
};

export default ProfileRouter;
